module.exports = __webpack_public_path__ + "static/media/kale.19914182.jpg";